import { Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class UiService {
  readonly $$title = signal('')
  readonly $$subtitle = signal(undefined as string | undefined)
  readonly $$showSidebar = signal(false)

  setTitle(title: string, subtitle?: string) {
    this.$$title.set(title)
    this.$$subtitle.set(subtitle)
  }

  toggleSidebar() {
    this.$$showSidebar.set(!this.$$showSidebar())
  }
}
